import { dataStrikethrough } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStrikethrough = /*#__PURE__*/createIcon(dataStrikethrough)
export default IconStrikethrough
